import React from 'react';
import { Redirect } from 'expo-router';

// Retired setup links enter the app through its email-verification gate.
export default function OnboardingRedirect() {
  return <Redirect href="/(app)/app" />;
}
